/**
 * @generated by Icons/generate-icons.ts — do not edit by hand.
 * Source: svg/QwickAI.svg. Edit that .svg (or svg/icons.config.json) and run
 * `pnpm --filter @gigpro/ui generate:icons`.
 */
import type { IconComponent } from "./types";

export const QwickAI: IconComponent = ({ ref, color = "currentColor", ...props }) => (
  <svg xmlns="http://www.w3.org/2000/svg" width="24" height="25" fill="none" viewBox="0 0 24 25" ref={ref} {...props}>
    <defs>
      <linearGradient
        id="QwickAI-paint0_linear_79_128"
        x1="-3.094"
        x2="23.532"
        y1="-2.198"
        y2="25.03"
        gradientUnits="userSpaceOnUse"
      >
        <stop stopColor="#5295ff" />
        <stop offset=".594" stopColor="#23cb6e" />
        <stop offset="1" stopColor="#209f5b" />
      </linearGradient>
    </defs>
    <path
      fill="url(#QwickAI-paint0_linear_79_128)"
      d="M10.336 1.087 3.79 4.242a3.83 3.83 0 0 0-2.074 2.603l-1.62 7.08a3.85 3.85 0 0 0 .738 3.244l4.531 5.682a3.83 3.83 0 0 0 2.998 1.444h7.269a3.84 3.84 0 0 0 3-1.444l4.531-5.681a3.82 3.82 0 0 0 .74-3.244l-1.616-7.087a3.83 3.83 0 0 0-2.074-2.603l-6.546-3.151a3.83 3.83 0 0 0-3.325 0z"
    />
    <path
      fill="#fff"
      d="M17.975 12.538c-4.123.507-5.17 1.554-5.677 5.677-.043.353-.553.353-.596 0-.507-4.123-1.554-5.17-5.677-5.677-.353-.043-.353-.553 0-.596 4.123-.507 5.17-1.554 5.677-5.677.043-.353.553-.353.596 0 .507 4.123 1.554 5.17 5.677 5.677.353.043.353.553 0 .596"
    />
  </svg>
);
QwickAI.displayName = "QwickAI";
